/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IPaymentScheme } from 'app/shared/model/payment-scheme.model';
import { IContactDetails } from 'app/shared/model/contact-details.model';
import { PaymentStatus } from 'app/shared/model/enumerations/payment-status.model';

export interface IPackageSubscription {
  id?: string;
  validFrom?: number;
  validTill?: number;
  remindFrom?: number;
  lockOutOn?: number;
  paidAmount?: number;
  pendingAmount?: number;
  expired?: boolean;
  active?: boolean;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  cursor?: number;
  subscriptionNumber?: string | null;
  suspended?: boolean | null;
  suspendedReason?: string | null;
  suspendedDate?: number | null;
  suspendedBy?: string | null;
  paymentStatus?: keyof typeof PaymentStatus | null;
  scheme?: IPaymentScheme | null;
  billToAddress?: IContactDetails | null;
}

export const defaultValue: Readonly<IPackageSubscription> = {
  expired: false,
  active: false,
  suspended: false,
};
